import { render, staticRenderFns } from "./LegalDocumentContent_wFP7pu.vue?vue&type=template&id=596e5976&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_wFP7pu.vue?vue&type=style&index=0&id=596e5976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596e5976",
  null
  
)

export default component.exports